
import React, { useEffect, useState } from "react";
import "./PopularBrands.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import StoreOfferCard from "./StoreOfferCard";

const PopularBrands = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPopularBrands = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}website/popular_brands`
        );
        if (data?.success) setBrands(data.data);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    fetchPopularBrands();
  }, []);

  const handleCardClick = (item) => {
    navigate(`/stores/${item.slug}`);
  };

  if (loading || brands.length === 0) return null;

  return (
    <section className="popular-brands">
      <div className="container">
        <div className="section-header">
          <h2>Most Popular Brands</h2>
        </div>

        <div className="brands-grid">
          {brands.map((item) => (
            <StoreOfferCard
              key={item._id}
              item={item}
              onClick={() => handleCardClick(item)}
            />
          ))}
        </div>

        <div className="brands-footer">
          <button
            className="btn brands-btn"
            onClick={() => navigate("/top-cashback-stores")}
          >
            View All Products
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularBrands;